export default {
  romaneios: [],
  colunasData: [
    { field: 'dataInicioOperacao', label: 'Início da operação' },
    { field: 'dataFimOperacao', label: 'Fim da operação' },
    { field: 'dataEmissao', label: 'Emissão' },
    { field: 'dataPrevisao', label: 'Previsão' },
    { field: 'dataEntrega', label: 'Entrega' },
    { field: 'dataPortaria', label: 'Portaria' },
    { field: 'dataChecklist', label: 'Checklist' },
    { field: 'dataConferencia', label: 'Conferência' },
    { field: 'dataEtiquetagem', label: 'Etiquetagem' },
    { field: 'dataEnderecamento', label: 'Endereçamento' },
    { field: 'dataConclusao', label: 'Conclusão' },
    { field: 'dataLiberacao', label: 'Liberação' },
    { field: 'dataColeta', label: 'Coleta' },
  ],
  romaneioSelecionado: undefined,
  expandColumns: [
    {
      value: 'descricao',
      text: 'descricao',
    },
    {
      value: 'qtdeServico',
      text: 'quantidade',
    },
    {
      value: 'valor',
      text: 'valorServico',
    },
    {
      value: 'valorCalculado',
      text: 'valorCalculado',
    },
  ],
  columns: [
    {
      value: 'depositante',
      text: 'depositante',
    },
    {
      value: 'codCalculo',
      text: 'codCalculo',
    },
    {
      value: 'estadoCalculo',
      text: 'estadoCalculo',
    },
    {
      value: 'dataInicio',
      text: 'dataInicio',
    },
    {
      value: 'dataFim',
      text: 'dataFim',
    },
    {
      value: 'valorTotal',
      text: 'valorTotal',
    },
  ],
};
